import React from 'react';
import { Link } from 'react-router-dom';

const DeepLinkShell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="dl-root">
    <header className="dl-header">
      <Link to="/" className="dl-header__mark" style={{ textDecoration: 'none' }}>
        LookBel
      </Link>
    </header>
    <main className="dl-main">{children}</main>
  </div>
);

export default DeepLinkShell;
